<template>
  <div class="container">
    <QueryFrame
      add-text=""
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>创建日期:</label>
            <timeStampDatePicker class="item" v-model="query.createTime" :options="disabledFromToday"  placeholder="请选择创建日期"></timeStampDatePicker>
          </div>
          <div class="queryItem" v-if="this.roleType !== 2">
            <label>创建人:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.createUserName"></lk-input>
          </div>
          <div class="queryItem">
            <label>菜单列表:</label>
            <lk-select class="item" v-model="query.menu" clearable>
              <lk-option v-for="item in menuList" :key="item" :value="item">{{item}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import download from '../../services/download';

export default {
  name: 'Download',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      query: {
        createTime: null,
        createUserName: '',
        menu: '',
      },
      menuList: [],
      timer: null,
      statusMap: new Map([
        [1, '导出中...'],
        [2, '完成'],
        [3, '已失效'],
      ]),
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '文件名',
          key: 'fileName',
          minWidth: 116,
        },
        {
          title: '创建时间',
          key: 'createTime',
          minWidth: 116,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
        },
        {
          title: '菜单列表',
          key: 'menu',
          minWidth: 116,
        },
        {
          title: '筛选条件',
          key: 'queryCondition',
          minWidth: 116,
        },
        {
          title: '导出进度',
          key: 'status',
          width: 188,
          render: (h, { row }) => h('span', this.statusMap.get(row.status)),
        },
        {
          title: '下载次数',
          key: 'downloadCount',
          minWidth: 116,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.status !== 2,
              },
              on: {
                click: () => {
                  this.downloadFile(row);
                },
              },
            }, '下载'),
          ]),
        },
      ],
      tableData: [],
      disabledFromToday: {
        disabledDate: utils.forbiddenDate.disabledFromToday,
      },
    };
  },
  methods: {
    getData(loading) {
      return new Promise((resolve) => {
        this.params.page = this.page;
        this.params.size = this.size;
        // if (this.params.createTime) {
        //   this.params.createTime = new Date(this.params.createTime).getTime();
        // }
        this.$store.commit('setDisableLoading', loading);
        download.getDownloadList(this.params).then((res) => {
          if (res.data.status === 200) {
            const { count, list } = res.data.data;
            list.forEach((item) => {
              item.createTime = utils.formatTime(item.createTime);
              item.queryCondition = item.queryCondition || '-';
              item.downloadCount = item.downloadCount || 0;
            });
            this.count = count;
            this.tableData = list;
            resolve(list);
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    downloadFile(row) {
      download.downloadFile({ id: row.id }).then((res) => {
        utils.downLoadExcel(res, row.fileName, true);
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getMenuList() {
      download.getMenuList().then((res) => {
        if (res.data.status === 200) {
          this.menuList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleReset() {
      this.query = {};
    },
  },
  created() {
    this.getMenuList();
    this.handleSearch(true);

    this.timer = setInterval(() => {
      this.getData(true).then((data) => {
        let num = 0;
        data.forEach((item) => {
          if (item.status === 2) {
            num++;
          }
        });
        this.tableData = data;
        if (num === data.length) { // 没有数据或者都是完成状态
          clearInterval(this.timer);
        }
      });
    }, 5000);
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="less" scoped>
</style>
